import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function ContactThree() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className="contactThree">
        <h1 className={`${isVisible ? "visible" : ""}`}>
          {t("contact_three_title")}
        </h1>
        <p className={`${isVisible ? "visible" : ""}`}>
          {t("contact_three_text")}
        </p>
        <a
          className={`${isVisible ? "visible" : ""}`}
          href="/anonymousReports"
          reloadDocument
        >
          <button>{t("contact_three_btn")}</button>
        </a>
      </div>
    </VisibilitySensor>
  );
}
export default ContactThree;
